import { render, staticRenderFns } from "./VisitPrediction.vue?vue&type=template&id=275d9b6e&"
import script from "./VisitPrediction.vue?vue&type=script&lang=js&"
export * from "./VisitPrediction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports